import { useNavigate } from 'react-router-dom';
import ListScreen from '../../../components/listScreen/ListScreen';
import { ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST } from '../../../dao/dbConstants';

const SupportRequests = () => {
  const navigate = useNavigate();

  const handleRowClick = (row) => {
    navigate('/bo/support-request/' + row.id);
  };

  return (
    <ListScreen
      entityName={ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST}
      heading="Support Requests"
      showAddButton={false}
      showSearch={true}
      enableRowClick={true}
      onRowClick={handleRowClick}
    />
  );
};

export default SupportRequests;